import React, { useEffect, useState } from 'react';
import { HandHeart } from '@phosphor-icons/react';
import client from '../../api/client';
import AppIcon from '../AppIcon';

const money = (c, cur = 'usd') => `${cur === 'cad' ? 'CA$' : '$'}${(c / 100).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;

export const ContributionsList = ({ toast }) => {
  const [d, setD] = useState(null);
  useEffect(() => { client.get('/gifts/contributions').then(({ data }) => setD(data)).catch(() => setD({ contributions: [], total_cents: 0 })); }, []);
  const thank = async (c) => {
    setD({ ...d, contributions: d.contributions.map((x) => x.id === c.id ? { ...x, thanked: !c.thanked } : x) });
    try { await client.put(`/gifts/contributions/${c.id}`, { thanked: !c.thanked }); }
    catch (e) { toast?.({ title: 'Could not update', description: e.message, variant: 'destructive' }); }
  };
  if (!d) return null;
  const todo = d.contributions.filter((c) => !c.thanked).length;
  return (
    <section data-testid="contributions-list" className="soft-card bg-white rounded-2xl border border-[#EFE3D8] p-5">
      <div className="flex items-center gap-3 mb-3">
        <AppIcon icon={HandHeart} tone="rose" size="md" reveal />
        <div className="flex-1">
          <h2 className="font-serif text-xl text-[#2A2A2A]">Contributions</h2>
          <p className="text-xs text-[#6A6A6A]"><span data-testid="contributions-total">{money(d.total_cents)}</span> received · {todo} thank-you{todo === 1 ? '' : 's'} to send</p>
        </div>
      </div>
      <ul className="divide-y divide-[#F2E8DE]">
        {d.contributions.map((c) => (
          <li key={c.id} data-testid={`contribution-${c.id}`} className="py-3 flex items-start gap-3">
            <div className="flex-1 min-w-0">
              <p className="text-sm text-[#2A2A2A]"><strong className="font-medium">{c.name}</strong> gave {money(c.gift_cents, c.currency)} to {c.item_title}</p>
              {c.note && <p className="text-xs text-[#4A4A4A] italic mt-0.5">"{c.note}"</p>}
              <p className="text-[11px] text-[#9A8A7E] mt-0.5">{c.paid_at ? new Date(c.paid_at).toLocaleDateString() : ''}{c.email ? ` · ${c.email}` : ''}</p>
            </div>
            <label className="text-xs inline-flex items-center gap-1.5 cursor-pointer whitespace-nowrap">
              <input data-testid={`contribution-thanked-${c.id}`} type="checkbox" className="accent-[#7B2C3B]" checked={!!c.thanked} onChange={() => thank(c)} /> Thanked
            </label>
          </li>
        ))}
        {!d.contributions.length && <li className="py-4 text-sm text-[#9A8A7E]">No card gifts yet. They appear here as soon as a guest pays.</li>}
      </ul>
    </section>
  );
};

export default ContributionsList;
